import { css } from "styled-components";

import everettLightWoff from './fonts/everett/everett-light-webfont.woff';
import everettLightWoff2 from './fonts/everett/everett-light-webfont.woff2';
import everettMediumWoff from './fonts/everett/everett-medium-webfont.woff';
import everettMediumWoff2 from './fonts/everett/everett-medium-webfont.woff2';
import everettRegularWoff from './fonts/everett/everett-regular-webfont.woff';
import everettRegularWoff2 from './fonts/everett/everett-regular-webfont.woff2';

import saolRegularWoff from './fonts/saol/saoldisplay-regularitalic-webfont.woff';
import saolRegularWoff2 from './fonts/saol/saoldisplay-regularitalic-webfont.woff2';
import saolMediumWoff from './fonts/saol/saoldisplay-mediumitalic-webfont.woff';
import saolMediumWoff2 from './fonts/saol/saoldisplay-mediumitalic-webfont.woff2';

import timesSemiboldWoff from './fonts/timesNow/times_now_semibold-webfont.woff';
import timesSemiboldWoff2 from './fonts/timesNow/times_now_semibold-webfont.woff2';
import timesSemilightWoff from './fonts/timesNow/times_now_semilight-webfont.woff';
import timesSemilightWoff2 from './fonts/timesNow/times_now_semilight-webfont.woff2';

/* eslint-disable */

export const fontFaces = css`

/* --------- Everett --------- */

@font-face {
    font-family: 'everettlight';
    src: url(${everettLightWoff2}) format('woff2'),
         url(${everettLightWoff}) format('woff');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'everettmedium';
    src: url(${everettMediumWoff2}) format('woff2'),
         url(${everettMediumWoff}) format('woff');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'everettregular';
    src: url(${everettRegularWoff2}) format('woff2'),
         url(${everettRegularWoff}) format('woff');
    font-weight: normal;
    font-style: normal;
}

/* --------- Saol Display --------- */

@font-face {
    font-family: 'saol-regular-italic';
    src: url(${saolRegularWoff2}) format('woff2'),
         url(${saolRegularWoff}) format('woff');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'saol-medium-italic';
    src: url(${saolMediumWoff2}) format('woff2'),
         url(${saolMediumWoff}) format('woff');
    font-weight: normal;
    font-style: normal;
}

/* --------- Times Now --------- */

@font-face {
    font-family: 'times-semilight';
    src: url(${timesSemilightWoff2}) format('woff2'),
         url(${timesSemilightWoff}) format('woff');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'times-semibold';
    src: url(${timesSemiboldWoff2}) format('woff2'),
         url(${timesSemiboldWoff}) format('woff');
    font-weight: normal;
    font-style: normal;
}
`;
